export const ImportInvoiceDescription = [
  "I/We declare that all conditions or restrictions, if any, imposed by the seller of any third party on the disposition or use of the imported goods [as per proviso to Rule 3(2)) of the Customs Valuation Rules, 2007] are specified above.",

  "I/We declare that the price paid or payable by the importer is as per the details provided above, and any price paid or payable in addition to the above will be settled with the seller at the end of a defined period by means of debit note / credit note (post – import price adjustment), which are as per the contract attached as a supporting document.",

  "I/We declare that there are no payments actually paid or payable for the imported goods by way of cost and services [in terms of Rules 10(1)(a)(i), Rule 10(1)(a)(ii), Rule 10 (1) (a) (iii) and Rule 10 (1) (b) of Customs Valuation Rules, 2007], Royalty / Licence Fee / subsequent resale or use of goods /other payment as a condition of sale [(Please see Rule 10 (1) (c), (d) & (e) of Customs Valuation Rules, 2007] other than those declared in the invoice which are mentioned as miscellaneous charges in this Bill of Entry.",

  "I/We are not related to the seller of the goods covered under above-mentioned invoices) in terms of Rule 2(2) of the Customs Valuation Rules, 2007",

  "I/We are related to the seller of the goods covered under the above-mentioned invoice(s) and our nature of relationship in terms of Rule 2(2) of the Customs Valuation Rules, 2007 has been examined by the Special Valuation Branch of the Customs House as per the reference number provided in the above invoice(s). I/We further declare that the terms & conditions of the agreement or pattern of invoicing has not changed since previously examined by the Special Valuation Branch, or that all changes the terms & conditions of the agreement or pattern of invoicing, since previous examination by the Special Valuation Branch.",
];

export default {
  row1: [
    {
      column: "column1",
      //   columnWidth: "45%",
      rows: {
        row1: [
          {
            name: "importInvoiceDeclarationType",
            label: "Declaration Type",
            component: "dropdown",
            width: "49%",
            options: [
              {
                label: "Declaration",
                value: "Declaration",
              },
              {
                label: "Undertaking",
                value: "Undertaking",
              },
              {
                label: "Remark",
                value: "Remark",
              },
            ],
          },
          {
            name: "declarationCode",
            label: "Title",
            component: "dropdown",
            width: "49%",
            options: [
              {
                label: "CUV01 - Valuation Declaration - I",
                value: "CUV01 - Valuation Declaration - I",
              },
              {
                label: "CUV02 - Valuation Declaration - II",
                value: "CUV02 - Valuation Declaration - II",
              },
              {
                label: "CUV03 - Valuation Declaration - III",
                value: "CUV03 - Valuation Declaration - III",
              },
              {
                label: "CUV04 - Related Party Declaration",
                value: "CUV04 - Related Party Declaration",
              },
              {
                label: "CUV05 - Related Party Declaration",
                value: "CUV05 - Related Party Declaration",
              },
            ],
          },
        ],
        row2: [
          {
            name: "declarationRemarks",
            component: "textarea",
            width: "100%",
            height: 100,
            sx: {
              borderRadius: 10,
            },
            disabled: true,
            isGet: false,
          },
        ],
      },
    },
  ],
};
